import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import LoadingSpinner from "../components/LoadingSpinner";
import TrackProgressDetail from "../components/TrackProgressDetail";
import { ChevronLeft } from "lucide-react";

export default function TrackProgress() {
  const { childId } = useParams();
  const navigate = useNavigate();
  const [isEnabled, setIsEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await api.get(`/children/profiles/${childId}/`);
        setIsEnabled(response.data.track_progress || false);
      } catch (error) {
        console.error("Error fetching status:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStatus();
  }, [childId]);

  const handleEnableFeature = async () => {
    try {
      await api.patch(`/children/profiles/${childId}/`, { track_progress: true });
      setIsEnabled(true);
    } catch (error) {
      console.error("Error enabling feature:", error);
    }
  };

  if (loading) return <LoadingSpinner fullScreen={true} />;

  if (isEnabled) {
    return <TrackProgressDetail title="Track Progress" />;
  }

  return (
    <div className="relative min-h-screen bg-white">
      <div className="relative z-10">
        <div className="bg-white/0 backdrop-blur-sm px-5 py-4 flex items-center justify-between">
          <button onClick={() => navigate(-1)} className="p-2">
            <ChevronLeft className="w-6 h-6 text-gray-800" />
          </button>
          <h1 className="text-lg font-semibold text-[#1e3a5f]">Track Progress</h1>
          <div className="w-10" />
        </div>
        <div className="px-5 py-6 flex flex-col items-center min-h-[calc(100vh-140px)]">
          <div className="flex-1 flex flex-col items-center justify-center max-w-md w-full">
            <div className="mb-8">
              <img
                src="/trackprogress.png"
                alt="Track Progress Illustration"
                className="w-100 h-100 object-contain"
              />
            </div>
            <h2 className="text-2xl font-bold text-[#1e3a5f] text-center mb-4">
              Track Progress
            </h2>
            <p className="text-gray-600 text-center mb-8 leading-relaxed">
              Visually track developmental milestones and celebrate every achievement on their unique journey.
            </p>
          </div>
          <div className="w-full max-w-md mt-auto pb-6">
            <button
              onClick={handleEnableFeature}
              className="w-full rounded-xl bg-[#1e3a5f] py-3.5 text-sm font-semibold text-white shadow-md transition-transform active:scale-98"
            >
              View Progress
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
